import ItemsShowPage from '../../components/pages/items/ItemsShowPage.vue'
export default {
  components: {
    ItemsShowPage
  }
}
